import { render, staticRenderFns } from "./UpdateBillingPeriod.vue?vue&type=template&id=ca65f23e&scoped=true"
import script from "./UpdateBillingPeriod.vue?vue&type=script&lang=js"
export * from "./UpdateBillingPeriod.vue?vue&type=script&lang=js"
import style0 from "./UpdateBillingPeriod.vue?vue&type=style&index=0&id=ca65f23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65f23e",
  null
  
)

export default component.exports